import type { ApiResult } from '@goss/types';
import { supabase } from './supabase.js';

// In production the SPA (Pages) and API (Worker) are on different origins, so
// calls must target the Worker's absolute URL. In local dev this is empty and
// Vite proxies the relative /api path to the local Worker (see vite.config.ts).
const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/**
 * Fetch a Worker API endpoint, attaching the current Supabase access token.
 * Unwraps the { ok, data | error } envelope; throws on error.
 */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });

  const body = (await res.json()) as ApiResult<T>;
  if (!body.ok) throw new Error(body.error.message);
  return body.data;
}
